import { useStore } from 'reactflow'

export const useCanvasState = () =>
  useStore((state) => ({
    isConnecting: state.connectionNodeId !== null,
    connectionNodeId: state.connectionNodeId,
    connectionHandleId: state.connectionHandleId
  }))
